import {OfferType} from "../../../types/OfferType";
import {ISelectedRegionEstimatedPrice} from "../../actions/fetch_selected_region_estimated_price";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {commercialOffersLocationGenericDescription} from "./commercial_offers_location_generic_description";
import {flatOffersLocationGenericDescription} from "./flat_offers_location_generic_description";
import {houseOffersLocationGenericDescription} from "./house_offers_location_generic_description";
import {mixedOffersLocationGenericDescription} from "./mixed_offers_location_generic_description";
import {studioOffersLocationGenericDescription} from "./studio_offers_location_generic_description";

interface IParams {
    offerType: OfferType;
    filters?: {
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
    selectedRegionEstimatedPrices: ISelectedRegionEstimatedPrice[];
}

export const getLocationGenericDescription = ({offerType, filters, region, selectedRegionEstimatedPrices}: IParams) => {
    const descriptionProps = {region, selectedRegionEstimatedPrices};

    switch (offerType) {
        case OfferType.COMMERCIAL:
            return commercialOffersLocationGenericDescription(descriptionProps);
        case OfferType.FLAT:
            if (filters?.rooms_1 === 1) {
                return studioOffersLocationGenericDescription(descriptionProps);
            } else {
                return flatOffersLocationGenericDescription(descriptionProps);
            }
        case OfferType.HOUSE:
            return houseOffersLocationGenericDescription(descriptionProps);
        default:
            return mixedOffersLocationGenericDescription(descriptionProps);
    }
};
